export default "__VITE_ASSET__DzIz84sO__"